import i18next from 'i18next'

type Opts = {
  min: number
  max: number
}

type ResponseType = {
  isValid: boolean
  message: string
}

type HydrateFunction = (value: any) => any

export default ({ min = 0, max = Infinity }: Opts, hydrate: HydrateFunction = value => value) => (
  value: any
): ResponseType | undefined => {
  if (typeof value !== 'string') {
    return {
      isValid: false,
      message: i18next.t(`must be at least characters long`, { min }),
    }
  }
  const hydratedValue = hydrate(value)
  if (hydratedValue.length < min) {
    return {
      isValid: false,
      message: i18next.t(`must be at least characters long`, { min }),
    }
  } else if (hydratedValue.length > max) {
    return {
      isValid: false,
      message: i18next.t(`must be less than characters long`, { max }),
    }
  }

  return undefined
}
